import { DependencyList, RefObject, useEffect, useState } from "react";

export default function useContainerHeight(
  containerRef: RefObject<HTMLDivElement | null>,
  containerRefDependencies: DependencyList = []
) {
  const [containerHeight, setContainerHeight] = useState<number>(0);

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      const [container] = entries;

      if (container == null) {
        return;
      }

      setContainerHeight(container.contentRect.height);
    });

    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        resizeObserver.unobserve(containerRef.current);
      }
    };
  }, [containerRef, ...containerRefDependencies]);

  return containerHeight;
}
